import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional class names, with conflicting utilities deduped. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
